/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathGreater = createReactComponent("math-greater", "IconMathGreater", [
  ["path", { d: "M5 18l14 -6l-14 -6", key: "svg-0" }]
]);

export { IconMathGreater as default };
//# sourceMappingURL=IconMathGreater.js.map
